<mat-dialog-content class="mat-dialog--post">
  <app-shared-post *ngIf="post && user" [post]="post" [user]="user" [users]="users" [view]="'dialog'" class="app-shared-post"></app-shared-post>
</mat-dialog-content>
